import React, { useContext } from 'react'
import { Text, View, useWindowResizeSensor } from 'oio-react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { Link, Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import { ArrowRightIcon, BoltIcon, CloseIcon, EmailNotificationsGlyphIcon24,
   PageGlyphIcon24, PeopleIcon, ReportGlyphIcon24 } from 'assets/icons'
import SettingsPrivacyBlock from 'src/apps/Initiative/components/SettingsPrivacyBlock'
import Content from 'src/apps/InitiativeSettings/apps/Content'
import EmailNotifications from 'src/apps/InitiativeSettings/apps/EmailNotifications'
import General from 'src/apps/InitiativeSettings/apps/General'
import People from 'src/apps/InitiativeSettings/apps/People'
import Reports from 'src/apps/InitiativeSettings/apps/Reports'
import ProtoColumnNavButton from 'src/components/Settings/ProtoColumnNavButton'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const GroupSettings = ({ returnUrl }) => {
   const match = useRouteMatch()
   const { initiative } = useContext(InitiativeHierarchyContext)

   const { currentBreakpoint } = useWindowResizeSensor()
   const currentModeHasTwoColumns = currentBreakpoint > 'c'

   return (
      <View
         position="absolute"
         top="0px"
         left="0px"
         right="0px"
         bottom="0px"
         borderRadius="3px"
         backgroundColor="#fafafa"
         style={{ overflow: 'hidden' }}>
         <Helmet title={`Settings | ${initiative.name}`} />
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="absolute"
            top="0px"
            right="0px"
            left="0px"
            height="70px"
            padding="0px 20px 0px 20px"
            backgroundColor="#fff"
            borderBottom="1px solid #eee"
            zIndex="2">
            <View display="flex" alignItems="center">
               <View padding="0px 10px 0px 0px">
                  <Text size="2.5[a-d] 3[e-f]" weight="medium" color="#000">
                     {initiative.name}
                  </Text>
               </View>
               <View display="none[a-b] flex[c-f]" alignItems="center">
                  <View marginBottom="2px">
                     <ArrowRightIcon
                        width="9px"
                        height="9px"
                        color="#666"
                        strokeWidth="3px"
                     />
                  </View>
                  <View padding="0px 10px">
                     <Text size="2.5[a-d] 3[e-f]" color="#888">
                        {`${initiative.type.nameSingular} Settings`}
                     </Text>
                  </View>
               </View>
            </View>
            <Link to={returnUrl} style={{ display: 'flex', alignItems: 'center' }}>
               <CloseIcon width="24px" height="24px" color="#666" />
            </Link>
         </View>
         <Route
            exact={!currentModeHasTwoColumns}
            path={match.url}>
            <View
               position="absolute"
               top="70px"
               left="0px"
               width="auto[a-c] 300px[d-f]"
               bottom="0px"
               right="0px[a-d] auto[e-f]"
               borderRight="1px solid #eee"
               backgroundColor="#fcfcfc"
               scroll="on">
               <View backgroundColor="#eee">
                  <SettingsPrivacyBlock />
               </View>
               <ProtoColumnNavButton
                  linkName={`${initiative.type.nameSingular} Settings`}
                  linkTo={`${match.url}/general`}
                  icon={<BoltIcon className="icon" width="14px" height="14px" />}
               />
               <ProtoColumnNavButton
                  linkName={`${initiative.type.nameSingular} Tabs & Content`}
                  linkTo={`${match.url}/content`}
                  icon={<PageGlyphIcon24 className="icon" width="14px" height="14px" />}
               />
               <ProtoColumnNavButton
                  linkName="People, Roles & Permissions"
                  linkTo={`${match.url}/people`}
                  icon={<PeopleIcon className="icon" width="14px" height="14px" />}
               />
               <ProtoColumnNavButton
                  linkName="Email Notifications"
                  linkTo={`${match.url}/email-notifications`}
                  icon={<EmailNotificationsGlyphIcon24 className="icon" width="16px" height="16px" />}
               />
               <ProtoColumnNavButton
                  linkName="Reports"
                  linkTo={`${match.url}/reports`}
                  icon={<ReportGlyphIcon24 className="icon" width="14px" height="14px" />}
               />
            </View>
         </Route>
         <Switch>
            {currentModeHasTwoColumns && (
               <Redirect exact from={match.url} to={`${match.url}/general`} />
            )}
            <Route
               path={[
                  `${match.url}/general`,
                  `${match.url}/content`,
                  `${match.url}/email-notifications`,
                  `${match.url}/people`,
                  `${match.url}/reports`
               ]}>
               <View
                  position="absolute"
                  top="70px"
                  left="0px[a-c] 300px[d-f]"
                  right="0px"
                  bottom="0px"
                  backgroundColor="#fafafa"
                  scroll="on">
                  <Switch>
                     <Route path={`${match.path}/general`} component={General} />
                     <Route path={`${match.path}/content`} component={Content} />
                     <Route path={`${match.path}/email-notifications`} component={EmailNotifications} />
                     <Route path={`${match.path}/people`} component={People} />
                     <Route path={`${match.path}/reports`} component={Reports} />
                  </Switch>
               </View>
            </Route>
         </Switch>
      </View>
   )
}

GroupSettings.propTypes = {
   returnUrl: PropTypes.string.isRequired
}

export default GroupSettings
